// Hard-coded constants that are not provided by the backend

export const FITNESS_LEVEL = {
  Beginner: {
    icon: '🚶',
    description: "I'm new, just getting started"
  },
  BeginnerPlus: {
    icon: '🚶‍♂️',
    description: "I've started training and feel more confident with basic movements"
  },
  Intermediate: {
    icon: '💪',
    description: "I train regularly and know basic exercises"
  },
  IntermediatePlus: {
    icon: '💪🔥',
    description: "I'm consistent, improving steadily, and ready for more challenging workouts"
  },
  Advanced: {
    icon: '🏋️',
    description: "I want a challenge, I'm strong and experienced"
  }
};

export const GOAL = {
  BuildMuscles: {
    icon: '💪',
    description: `Muscle Growth ⭐⭐⭐ | Fat Burn ⭐`
  },
  TonedBody: {
    icon: '✨',
    description: `Muscle Growth ⭐⭐⭐ | Fat Burn ⭐⭐`
  },
  BurnFat: {
    icon: '🔥',
    description: `Muscle Growth ⭐⭐⭐ | Fat Burn ⭐⭐⭐`
  }
};

export const DOMINANT_SIDE = {
  Left: {
    icon: '👈',
    label: 'Left'
  },
  Right: {
    icon: '👉',
    label: 'Right'
  }
};

export const BOXING_PREFERENCE = {
  Yes: {
    icon: '🥊',
    label: 'Yes'
  },
  No: {
    icon: '❌',
    label: 'No'
  }
};

export const TRAINING_TYPE = {
  Standard: {
    icon: '🏋️',
    label: 'Build my body'
  },
  Athlete: {
    icon: '🤸',
    label: 'Improve in a sport'
  }
};

// Training Type Enum
export enum TrainingType {
  Standard = 'Standard',
  Athlete = 'Athlete',
}

export const WEEKLY_COMMITMENT_OPTIONS = [
  { value: 1, label: 'Day', recommended: false, description: 'Results in 8 weeks' },
  { value: 2, label: 'Days', recommended: true, description: 'Results in 6 weeks' },
  { value: 3, label: 'Days', recommended: true, description: 'Results in 4 weeks' },
  { value: 4, label: 'Days', recommended: true, description: 'Results in 3 weeks' },
  { value: 5, label: 'Days', recommended: false, description: 'Results in 2 weeks' },
  { value: 6, label: 'Days', recommended: false, description: 'Results in 2 weeks' },
];

export enum TimeAvailabilityPerSession {
  NoTimeRestriction = 'NoTimeRestriction',
  Min30To45 = 'Min30To45',
  Min45To60 = 'Min45To60',
  Min60To75 = 'Min60To75',
  Min75To90 = 'Min75To90',
}

export const TIME_AVAILABILITY_PER_SESSION = {
  [TimeAvailabilityPerSession.NoTimeRestriction]: {
    icon: '∞',
    label: 'No time restriction'
  },
  [TimeAvailabilityPerSession.Min30To45]: {
    icon: 'pi pi-clock',
    label: '30min - 45min'
  },
  [TimeAvailabilityPerSession.Min45To60]: {
    icon: 'pi pi-clock',
    label: '45min - 1h'
  },
  [TimeAvailabilityPerSession.Min60To75]: {
    icon: 'pi pi-clock',
    label: '1h - 1h15min'
  },
  [TimeAvailabilityPerSession.Min75To90]: {
    icon: 'pi pi-clock',
    label: '1h15min - 1h30min'
  }
};
  
// Full Body is not in the backend, so we hard-code it here
export const FULL_BODY_MUSCLE_GROUP = {
  value: '',
  label: 'Full Body',
  icon: '🧍',
  isFullBody: true
};

export const MUSCLE_GROUP_NAMES = [
  'Shoulders',
  'Chest',
  'Core',
  'Traps',
  'Back',
  'Lower Back',
  'Biceps',
  'Triceps',
  'Forearms',
  'Glutes',
  'Quadriceps',
  'Hamstrings',
  'Adductors',
  'Calves',
];

// Wizard steps configuration
export const WORKOUT_WIZARD_STEPS = [
  { number: 1, title: 'Size' },
  { number: 2, title: 'Dominant Side' },
  { number: 3, title: 'Boxing Preference' },
  { number: 4, title: 'Fitness Level' },
  { number: 5, title: 'Training Type' },
  { number: 6, title: 'Training Goal' },
  { number: 7, title: 'Health Assesment' },
  { number: 8, title: 'Focus Muscles' },
  { number: 9, title: 'Weekly Commitment' },
  { number: 10, title: 'Session Duration' },
  { number: 11, title: 'Branch' }
];
